<div class="prodHeaderTopSec">
  <div class="row">
    <div class="col-md-11 col-lg-9">
      <h2>Modify Product:</h2>
      <div class="row">
        <div class="col-md-12">
          <!--<p class="bold">-->
          <p>
            By: <span>{{btnAction}}</span> Current Product: <span>{{counter}} of {{totalItems}}</span>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 margin-t5">
          <p>
            When modifying multiple products you'll be able to go through this interface for each product and make your
            modifications. Once you're done you'll be able to commit your order change in its entirety.
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-12 padding-l0 padding-r0 " *ngIf="showCutOverWarning">
      <div class="warningMsg">
        {{cutOverPackageSizeMessage}}
      </div>
    </div>
  </div>
</div>

<div class="row modifyProdfromTable">
  <div class="col-md-12 tableHead ">
    From:
  </div>
  <div class="col-md-12">
    <div class="tableContainer topTable">
      <table class="matTables productTable mat-table noBorders">
        <tr class="mat-header-row">
          <th class="mat-header-cell productName">Product Name</th>
          <!--<th *ngIf="isEAModifiableUnitsShow" class="mat-header-cell text-center seedSize">EA Modifiable Units</th>-->
          <th class="mat-header-cell text-center seedSize">Seed Size</th>
          <th class="mat-header-cell text-center packSize">Package Size</th>
          <th class="mat-header-cell text-center treatment">Treatment</th>
          <th class="mat-header-cell text-center units">Units</th>         
        </tr>
        <tr class="mat-row">
          <td class="order-info mat-cell">
            <p>{{fromProduct.brand}}</p>
            <p class="grower-name">{{fromProduct.itemDescription}}</p>
            <p *ngIf="fromProduct.seedNonReturnable" class="grower-name nonReturnable">*NON-RETURNABLE</p>
          </td>
          <!--<td *ngIf="isEAModifiableUnitsShow" class="text-center mat-cell">
            <span>{{fromProduct.eaModifiableUnits}}</span>
          </td>-->
          <td class="text-center mat-cell">
            <span>{{fromProduct.seedSize}}</span>
          </td>
          <td class="text-center mat-cell">
            <span [ngClass]="{'oval-shape pack-size': (fromProduct?.highlightPackage===1)}" matTooltip="{{fromProduct.packageSize}}" [matTooltipPosition]="'above'">
              {{fromProduct.packageSize}}
            </span>
          </td>
          <td class="text-center mat-cell">
            <span [ngClass]="{'oval-shape treatment': (fromProduct?.highlightTreatment===1)}" matTooltip="{{fromProduct.treatment}}" [matTooltipPosition]="'above'">
              {{fromProduct.treatment}}
            </span>
          </td>
          <td class="text-center mat-cell">
            <span class="units-sec">{{commonService.getFormatedNumber(fromProduct.geu) | number}}</span>
          </td>        
        </tr>
      </table>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-12 tableHead whiteBg">
    To:
  </div>
  <div class="col-md-12 padding-l10">
    <div class="tableContainer modifyProdTable margBottom">
      <table class="matTables productTable mat-table newClass">
        <thead>
          <tr class="mat-header-row">
            <th class="mat-header-cell availibility-head" matTooltip="Availability" [matTooltipPosition]="'above'">Avail.</th>
            <th class="mat-header-cell availibility-head" matTooltip="My Dealer Bucket" [matTooltipPosition]="'above'">MDB</th>
            <th class="mat-header-cell productName">Product Name</th>
            <th class="mat-header-cell text-center seedSize">Seed Size</th>
            <th class="mat-header-cell text-center packSize">Package Size</th>
            <th class="mat-header-cell text-center treatment">Treatment</th>
            <th class="mat-header-cell text-center unit">Units</th>
          </tr>
        </thead>
        <tbody *ngFor="let element of changeListDS">
          <tr class="mat-row">
            <td class="available-block text-center mat-cell"><span class="seed-avail">{{element.seedAvailability }}</span></td>
            <td class="available-block text-center mat-cell">
              <span class="seed-avail" *ngIf="element.myDealerBucketQty>=0">{{commonService.getFormatedNumber(element.myDealerBucketQty) | number}}</span>
              <span class="seed-avail" *ngIf="element.myDealerBucketQty<0">({{commonService.getFormatedNumber(element.myDealerBucketQty | positiveValue) | number}})</span>
            </td>
            <td class="order-info mat-cell" [attr.data-testid]="element.itemNumber">
              <p class="d-block d-md-none padding-l5">Product</p>
              <p><a>{{element.brand }}-{{element.itemNumber}}</a></p>
              <p class="grower-name">{{ element.itemDescription}}</p>
              <p *ngIf="element.seedNonReturnable" class="grower-name nonReturnable">*NON-RETURNABLE</p>
            </td>
            <td class="text-center mat-cell">
              <span>
                {{element.seedSize}}
              </span>
            </td>
            <td class="text-center mat-cell">
              <span [ngClass]="{'oval-shape pack-size': (element?.highlightPackage===1)}" matTooltip="{{element.packageSize}}" [matTooltipPosition]="'above'">
                {{element.packageSize}}
              </span>
            </td>
            <td class="text-center mat-cell">
              <span [ngClass]="{'oval-shape treatment': (element?.highlightTreatment===1)}" matTooltip="{{element.treatment}}" [matTooltipPosition]="'above'">
                {{element.treatment}}
              </span>
            </td>
            <td class="text-center mat-cell product-line">
              <div>
                <button *ngIf="element.isProductDeactivated === false
                        || dealerPartial(element)
                        || (page != 'dealerSlider' && (element.deactivationType != null && element.deactivationType.trim().toLowerCase() != 'suspend'))"
                        (click)="geuValueChange('decrease',element);element.isSelected=true" class="plus-minus-btn minusBtn" [attr.data-testid]="'decrease-' + element.itemNumber">
                  -
                </button>
                <input *ngIf="page === 'growerOrder'" [readonly]="element.isProductDeactivated == true
                       && (!dealerPartial(element) || (element.deactivationType != null && element.deactivationType.trim().toLowerCase() == 'suspend'))" type="text" class="geu-txt" [(ngModel)]="element.geu" (focus)="element.isSelected=true" (focusout)="validateQty(element)"
                       [ngClass]="{invalidinput : element.errorFlag}" appThreeDigitDecimaNumber [attr.data-testid]="'qty-' + element.itemNumber" />
                <input *ngIf="page !== 'growerOrder'" [readonly]="element.isProductDeactivated == true
                       && (!dealerPartial(element) || (element.deactivationType != null && element.deactivationType.trim().toLowerCase() == 'suspend'))" type="text" class="geu-txt" [(ngModel)]="element.geu" (focus)="element.isSelected=true" (focusout)="validateQty(element)"
                       [ngClass]="{invalidinput : element.errorFlag}" appNumbersOnly [attr.data-testid]="'qty-' + element.itemNumber" />
                <button *ngIf="element.isProductDeactivated === false
                        || dealerPartial(element)
                        || (page != 'dealerSlider' && (element.deactivationType != null && element.deactivationType.trim().toLowerCase() != 'suspend'))"
                        (click)="geuValueChange('increase',element); element.isSelected=true" class="plus-minus-btn plusBtn" [attr.data-testid]="'increase-' + element.itemNumber">
                  +
                </button>
              </div>
              <div class="unavailableMsg" *ngIf="element.isProductDeactivated === true &&
                   (page == 'dealerSlider' && !dealerPartial(element) || (element.deactivationType != null && element.deactivationType.trim().toLowerCase() == 'suspend'))">
                <div id="main_{{element.itemNumber}}">
                  <div class="unavail-content" id="sub_{{element.itemNumber}}">
                    <h4>This item is currently unavailable for ordering.</h4>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td [attr.colspan]="isEAModifiableUnitsShow ? 8 : 7" *ngIf="element.errorFlag">
              <div class="inline-error">
                <div class="row">
                  <div class="col-md-12">
                    <ol class="error-list">
                      <li *ngFor="let error of element.errors" class="justify-content-center align-self-center">
                        {{error.msg }}
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div class="tableTotalsSec">
  <div class="row">
    <div class="col-md-9">
      <button mat-raised-button *ngIf="isShowPreviousBtn" class="btns" color="primary" (click)="MoveToPreviousItem()">Previous Line Item</button>
      <button mat-raised-button *ngIf="isShowNextBtn" class="btns" color="primary" (click)="MoveToNextItem()">{{btnTxt}}</button>
      <button mat-raised-button class="btns" color="primary" (click)="addProducts(true)">Preview Change</button>
      <!--<a (click)="addProducts(true)" style="cursor:pointer">Preview Change </a>-->
      <a (click)="addProducts(false)" style="cursor:pointer">Cancel </a>
    </div>
    <div class="col-md-3 text-right count">
      Modified Units: <span>{{commonService.getFormatedNumber(totalSum) | number}}/{{commonService.getFormatedNumber(fromProduct.geu) | number}}</span>
    </div>
  </div>
</div>
